import { isValidElement } from 'react';
import {v4 as uuidv4} from 'uuid';

const FAQmyData = [
    {
        id: uuidv4(),
        ques: '1976 ',
        ans: ' Foundation of Shree Gita Group by Mr. Naginbhai Bhojani, starting with an oil mill (seed crushing) unit with a daily capacity of 20 MT.',
        index: 'faq1',
    },

    {
        id: uuidv4(),
        ques: '1991 ',
        ans: ' Launched Cotton Ginning and Pressing Division with a manual system, producing 10 MT of raw cotton per day.',
        index: 'faq2'
    },

    {
        id: uuidv4(),
        ques: '1993 ',
        ans: 'Expanded oil mill capacity to 50 MT per day.',
        index: 'faq3'
    },

    {
        id: uuidv4(),
        ques: '1997 ',
        ans: ' Further increased oil seed crushing capacity to 90 MT per day, while ginning capacity rose to 30 MT per day.',
        index: 'faq4'
    },

    {
        id: uuidv4(),
        ques: '2004 ',
        ans: 'Installed an Edible Oil Refining Unit with a capacity of 100 MT per day.',
        index: 'faq5'
    },
    {
        id: uuidv4(),
        ques: '2005  ',
        ans: ' Increased ginning capacity to 100 MT per day. ',
        index: 'faq6'
    },
    {
        id: uuidv4(),
        ques: '2007  ',
        ans: 'Launched the Agro Trading Division, engaging in the marketing, import, and export of raw cotton, edible and non-edible oils, oil cakes, de-oiled cakes (meals), oilseeds, grains, pulses, cereals, beans, spices, and cotton yarn.',
        index: 'faq7'
    },
    {
        id: uuidv4(),
        ques: '2012  ',
        ans: 'Achieved a total trading volume of 30,000 MT of raw cotton across domestic and international markets.',
        index: 'faq8'
    },

]

export default FAQmyData;